import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HelperService {

  constructor() { }

  //creates a GUID
  createGUID(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0,
      v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  //checks email - prevents personal email
  checkEmail(strEmail: string): boolean {
    if (strEmail.indexOf('icloud.com') > 0 || strEmail.indexOf('yahoo.com') > 0 || strEmail.indexOf('gmail.com') > 0) {
      //invalid
      return false;
    } else {
      //valid
      return true;
    }
  }
}
